/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DataMappingFromJSON, DataMappingToJSON } from './';
export function ExportConfigurationRepresentationFromJSON(json) {
    return ExportConfigurationRepresentationFromJSONTyped(json, false);
}
export function ExportConfigurationRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        name: !exists(json, 'name') ? undefined : json['name'],
        flag: json['flag'],
        dataMapping: DataMappingFromJSON(json['dataMapping']),
    };
}
export function ExportConfigurationRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        name: value.name,
        flag: value.flag,
        dataMapping: DataMappingToJSON(value.dataMapping),
    };
}
